import { useContext, createContext } from 'react';

export const isLoggedIn = createContext();

export function useAuth() {
  return useContext(isLoggedIn);
}